const doc = [({"en":({"js":({"user_steps":({"element_types":({"question_dropdown":({"choose_one_of_the_options":"Choose one of the options"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;